var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Edit_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1614 64.1041L57.1104 21.4949C58.9011 19.1972 59.5378 16.5406 58.9409 13.8357C58.4236 11.3767 56.9114 9.03866 54.6432 7.26495L49.1119 2.871C44.2969 -0.958591 38.3279 -0.555476 34.9057 3.83848L31.2049 8.63957C30.7273 9.24022 30.8467 10.1271 31.4436 10.6108C31.4436 10.6108 40.7951 18.1087 40.994 18.27C41.6307 18.8747 42.1083 19.6809 42.2276 20.6484C42.4266 22.543 41.1134 24.3167 39.1635 24.5586C38.2483 24.6795 37.3728 24.3973 36.7361 23.8733L26.9072 16.0529C26.4297 15.6941 25.7134 15.7707 25.3154 16.2544L1.95671 46.488C0.444558 48.3827 -0.0727562 50.8417 0.444558 53.22L3.42906 66.16C3.58824 66.8453 4.18514 67.3291 4.90142 67.3291L18.0332 67.1678C20.4208 67.1275 22.6493 66.0391 24.1614 64.1041ZM42.5487 60.0745H63.9615C66.0507 60.0745 67.7499 61.7958 67.7499 63.9121C67.7499 66.0325 66.0507 67.7498 63.9615 67.7498H42.5487C40.4595 67.7498 38.7604 66.0325 38.7604 63.9121C38.7604 61.7958 40.4595 60.0745 42.5487 60.0745Z",
    fill: "#F9F5FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.48ea361b0f2af89a54f1718cefdbc966.svg";
export { ForwardRef as ReactComponent };